import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';

import TextField from '@mui/material/TextField';

import { DateProvider } from '../../providers';

import { Container } from './styles';

function DateTimeInput({ onSetTime }) {
  const [date, setDate] = useState(Date.now());

  const onChangeDate = (e) => {
    const datetime = e.target.value
      ? new Date(e.target.value).getTime()
      : e.target.value;
    setDate(datetime);
    onSetTime(datetime || Date.now());
  };

  return (
    <Container>
      <TextField
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        label={i18n.t('components.dateTime.label')}
        onChange={onChangeDate}
        type="datetime-local"
        value={DateProvider.getInputDateFormat(date)}
        variant="outlined"
      />
    </Container>
  );
}

DateTimeInput.propTypes = {
  haveHours: PropTypes.bool,
  onSetTime: PropTypes.func,
};

DateTimeInput.defaultProps = {
  haveHours: false,
  onSetTime: undefined,
};

export default DateTimeInput;
